var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRteH3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "10px",
    viewBox: "0 0 19 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rich-text-updates",
    transform: "translate(-457.000000, -116.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-h3",
    transform: "translate(458.000000, 116.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5,5 L6.75,5",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 1.42857143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.714285714 L2.25,0.714285714",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 1.42857143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,9.28571429 L2.25,9.28571429",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 1.42857143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.125,1.07142857 L1.125,8.92857143",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 2.14285714,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,0.714285714 L8.25,0.714285714",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 1.42857143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,9.28571429 L8.25,9.28571429",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 1.42857143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.125,1.07142857 L7.125,8.92857143",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 2.14285714,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5255,5.33214286 L14.4855,5.33214286 C15.153,5.33214286 15.59175,4.97571429 15.59175,4.43357143 C15.59175,3.89142857 15.1635,3.55571429 14.469,3.55571429 C13.78575,3.55571429 13.3245,3.94285714 13.30275,4.52714286 L11.49675,4.52714286 C11.5245,3.07 12.696,2.14 14.5125,2.14 C16.248,2.14 17.44125,2.97142857 17.44125,4.175 C17.44125,5.03285714 16.839,5.70928571 15.96075,5.86428571 L15.96075,5.96214286 C17.04,6.07071429 17.72925,6.74714286 17.72925,7.70785714 C17.72925,9.05642857 16.395,9.99642857 14.48025,9.99642857 C12.6525,9.99642857 11.421,9.04571429 11.3505,7.58428571 L13.24875,7.58428571 C13.27575,8.15285714 13.75875,8.50357143 14.5125,8.50357143 C15.2175,8.50357143 15.70575,8.12142857 15.70575,7.56357143 C15.70575,6.99 15.2445,6.63857143 14.4855,6.63857143 L13.5255,6.63857143 L13.5255,5.33214286 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRteH3);
export default __webpack_public_path__ + "static/media/icon-rte-h3.e4a183f1d8af40512c321ab3e2c4e5a9.svg";
export { ForwardRef as ReactComponent };